<template>
  <v-container>
    <PageHeader title="Review" />
    <v-card v-if="activity" tile>
      <SectionHeader class="d-none d-sm-block px-6 pt-4" title="Review your document">
        <template #subtitle>
          <p class="body-1">
            Here you can view the translations on your template translation.
          </p>
          <p class="body-1 d-none d-md-block">
            If the provider makes any edits, you will be notified via email and they will be available for you to review on this page.
          </p>
        </template>
      </SectionHeader>
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <DesktopTranslateTable :fields="fields" is-read-only />
      </div>
      <div v-else>
        <MobileTranslateForm v-if="fields.length" :fields="fields" is-read-only />
      </div>
      <div class="d-flex justify-end pa-4 pt-md-0">
        <v-btn color="tertiary" outlined style="min-width: 160px" @click="$router.back()">
          Back to Job
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import PageHeader from '@/domains/global/components/PageHeader.vue'
import SectionHeader from '@/domains/global/components/SectionHeader.vue'
import DesktopTranslateTable from '@/domains/activities/components/TranslateTable/DesktopTranslateTable.vue'
import MobileTranslateForm from '@/domains/activities/components/TranslateTable/MobileTranslateForm.vue'
import { consumeError } from '@/domains/global/utils'

export default Vue.extend({
  components: { PageHeader, SectionHeader, DesktopTranslateTable, MobileTranslateForm },
  data() {
    return {
      activity: null,
      fields: [],
      isLoading: true
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      await this.getActivity()
      await this.getMarkups()
    },
    async getActivity() {
      try {
        const response = await axios.get(`/jobs/${this.$route.params.jobId}/activities/${this.$route.params.id}`)
        this.activity = response.data
      } catch (error) {
        const formattedError = consumeError(error)
        if (formattedError.code !== 'SENTRY') {
          this.$store.dispatch('error', formattedError.message)
        } else {
          Sentry.captureException(error)
        }
      }
    },
    async getMarkups() {
      try {
        const response = await axios.get(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/markups`)
        this.fields = response.data
      } catch (error) {
        const formattedError = consumeError(error)
        if (formattedError.code !== 'SENTRY') {
          this.$store.dispatch('error', formattedError.message)
        } else {
          Sentry.captureException(error)
        }
      }
    }
  }
})
</script>
